module.exports = __webpack_public_path__ + "img/pic-story-tab1-3.da0d04e6.jpg";